import { render } from "./HeadMain.vue?vue&type=template&id=038b208d&scoped=true"
import script from "./HeadMain.vue?vue&type=script&lang=js"
export * from "./HeadMain.vue?vue&type=script&lang=js"

import "./HeadMain.vue?vue&type=style&index=0&id=038b208d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-038b208d"]])

export default __exports__